import { useEffect, useState } from "react";

const useAdmin = (user) => {
  const [admin, setAdmin] = useState(false);
  const [adminLoading, setAdminLoading] = useState(true);
  useEffect(() => {
    const email = user?.email;
    if (email) {
      fetch(`https://warm-caverns-09302.herokuapp.com/admin/${email}`,{
          method: 'GET',
          headers:{
              'authorization': `Bearer ${localStorage.getItem('accessToken')}`,
              "Content-Type": "application/json",
          }
      })
        .then(res => res.json())
        .then((data) => {
            setAdmin(data.admin);
            setAdminLoading(false);
        });
    }
  }, [user]);
  return [admin, adminLoading];
};
export default useAdmin;
